import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    const status = err?.response?.status;
    if (status === 401 && localStorage.getItem("rk_token") && !url.includes("/auth/login")) {
      localStorage.removeItem("rk_token");
      window.dispatchEvent(new Event("rk-session-expired"));
    }
    if (status === 403 && !url.includes("/auth/")) {
      window.dispatchEvent(new Event("rk-perms-changed"));
    }
    return Promise.reject(err);
  }
);

// Background-load errors: 401 is handled globally by the session-expired toast
export const isSessionError = (err) => err?.response?.status === 401;

export const errMsg = (err, fallback = "Terjadi kesalahan") => {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(", ") || fallback;
  if (typeof d === "string") return d;
  return fallback;
};

export const formatRupiah = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(n);
